import { Card, CircularProgress } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDetailsAuthorizations } from "../../../../actions/authorizations";
import { StyledDetailsTable } from "../../../styled/authorizations";
import { tableConfig } from "../config/tableConfig";

const DetailsTableAuthorizations = ({ rowData }) => {
  const dispatch = useDispatch();

  const detailsAnsweredAuthorizations = useSelector(
    (state) => state.answeredAuthorizations,
  );
  const detailsPendingAuthorizations = useSelector(
    (state) => state.pendingAuthorizations,
  );

  const detailsAuthorizations =
    rowData.respondida === true
      ? detailsAnsweredAuthorizations
      : detailsPendingAuthorizations;

  const siniestroId = rowData.siniestroId;
  const formNumber = rowData.nroFormulario;
  const artId = rowData.artMLCloud;
  const respondida = rowData.respondida;
  const siniestroDetails = detailsAuthorizations.listDetails[siniestroId];
  const formDetails = siniestroDetails?.[formNumber];

  useEffect(() => {
    if (!siniestroDetails || !formDetails) {
      dispatch(
        getDetailsAuthorizations(siniestroId, artId, formNumber, respondida),
      );
    }
  }, [
    siniestroDetails,
    formDetails,
    dispatch,
    siniestroId,
    formNumber,
    artId,
    respondida,
  ]);

  const columns = rowData.respondida
    ? [
      { accessorKey: "codigo", header: "Código" },
      { accessorKey: "nombre", header: "Nombre" },
      { accessorKey: "cantidad", header: "Cantidad" },
      { accessorKey: "autorizado", header: "Autorizado" },
      { accessorKey: "estado", header: "Estado" },
    ]
    : [
      { accessorKey: "codigo", header: "Código" },
      { accessorKey: "nombre", header: "Nombre" },
      { accessorKey: "cantidad", header: "Cantidad" },
    ];

  const data =
    detailsAuthorizations.listDetails[rowData.siniestroId]?.[
      rowData.nroFormulario
    ]?.map((item) => ({
      codigo: item.codigo || "---",
      nombre: item.nombre || "---",
      cantidad: item.cantidad || "---",
      autorizado: item.autorizado ? "Sí" : "No",
      estado: item.estado || "---",
    })) || [];

  return (
    <StyledDetailsTable.Container>
      {(!detailsAuthorizations.listDetails[rowData.siniestroId] ||
        !detailsAuthorizations.listDetails[rowData.siniestroId][
        rowData.nroFormulario
        ]) &&
        detailsAuthorizations.isFetchingDetail ? (
        <Card>
          <StyledDetailsTable.Loading>
            <CircularProgress />
          </StyledDetailsTable.Loading>
        </Card>
      ) : (
        <Card>
          <StyledDetailsTable.Content>
            <StyledDetailsTable.Details>
              <StyledDetailsTable.TextTitle variant="h6">
                Solicitado por:{" "}
              </StyledDetailsTable.TextTitle>
              <StyledDetailsTable.TextValue>
                {rowData.solicitadoPor || "---"}
              </StyledDetailsTable.TextValue>
            </StyledDetailsTable.Details>

            <StyledDetailsTable.Details>
              <StyledDetailsTable.TextTitle variant="h6">
                Administrador:{" "}
              </StyledDetailsTable.TextTitle>
              <StyledDetailsTable.TextValue>
                {rowData.administrador || "---"}
              </StyledDetailsTable.TextValue>
            </StyledDetailsTable.Details>
          </StyledDetailsTable.Content>

          <StyledDetailsTable.Details>
            <StyledDetailsTable.TextTitle variant="h6">
              Detalle:{" "}
            </StyledDetailsTable.TextTitle>
            <StyledDetailsTable.TextValue>
              {rowData.detalle || "---"}
            </StyledDetailsTable.TextValue>
          </StyledDetailsTable.Details>

          <StyledDetailsTable.Table>
            <MaterialReactTable
              {...tableConfig}
              columns={columns}
              data={data}
              enableSorting={false}
              enableColumnFilters={false}
              enablePagination={false}
              muiTableBodyCellProps={{
                sx: {
                  fontSize: 12,
                },
              }}
              initialState={{
                density: "compact",
              }}
            />
          </StyledDetailsTable.Table>

          {rowData.respondida && (
            <StyledDetailsTable.AnsweredAuthorizationContainer>
              <StyledDetailsTable.Details>
                <StyledDetailsTable.TextTitle variant="h6">
                  Observaciones de Art:{" "}
                </StyledDetailsTable.TextTitle>
                <StyledDetailsTable.TextValue>
                  {rowData.observacionesAutorizacion || "---"}
                </StyledDetailsTable.TextValue>
              </StyledDetailsTable.Details>

              <StyledDetailsTable.Details>
                <StyledDetailsTable.TextTitle variant="h6">
                  Estado:{" "}
                </StyledDetailsTable.TextTitle>
                <StyledDetailsTable.TextValue>
                  {rowData.estado || "---"}
                </StyledDetailsTable.TextValue>
              </StyledDetailsTable.Details>
            </StyledDetailsTable.AnsweredAuthorizationContainer>
          )}
        </Card>
      )}
    </StyledDetailsTable.Container>
  );
};

export default DetailsTableAuthorizations;
